/* eslint-disable no-unused-vars */
import debugFactory from "debug";
import { clientIdentifier, listenTo } from "@teaming/io-helpers";
import { SocketMessageType } from "@teaming/common-enums";
import { debounce } from "@teaming/common-util";

export function configureSockets( { storeName, store, navigation, ioSocket, ioGokr, alerts, } ) {
	const debug = debugFactory( `teaming:common-gokr:stores:${ storeName }:sockets` );
	const getter = getterName => store.getters[ `${ storeName }/${ getterName }` ];
	const commit = ( mutationName, args ) => store.commit( `${ storeName }/${ mutationName }`, args );

	const { success, error, info, } = alerts;
	// eslint-disable-next-line no-magic-numbers
	const notifyExternalChange = debounce( () => info( "externalChangeNotification" ), 200 );

	[
		SocketMessageType.KEYRESULT_UPDATED,
	].forEach( socketEvent => {
		debug( `adding socket listener: ${ storeName } <= ${ socketEvent }` );
		ioSocket.addSocketMessageListener( socketEvent, async message => {
			debug( "received socket message", message );
			const { body, clientIdentifier: messageClientIdentifier, } = message;
			const { goalId, keyResultId = "", } = body;
			const isMessageFromMe = ( messageClientIdentifier === clientIdentifier );
			const isStoreKR = keyResultId === getter( "context" ).keyResultId;
			if ( isStoreKR ) {
				const { data: activity, } = await ioGokr.fetchGoalActivity( { goalId, }, { refetch: true, } );
				commit( "receiveGoalActivity", activity );
			}
			const inKRRoute = navigation.store.inKeyResultRoute( { goalId, keyResultId, } );
			if ( isStoreKR && inKRRoute && !isMessageFromMe ) {
				notifyExternalChange();
			}
		} );
	} );

	[
		SocketMessageType.GOAL_UPDATED,
	].forEach( socketEvent => {
		debug( `adding socket listener: ${ storeName } <= ${ socketEvent }` );
		ioSocket.addSocketMessageListener( socketEvent, async message => {
			debug( "received socket message", message );
			const { body, clientIdentifier: messageClientIdentifier, } = message;
			const { goalId, } = body;
			const isMessageFromMe = ( messageClientIdentifier === clientIdentifier );
			const isStoreParentGoal = ( goalId === getter( "context" ).goalId );
			if ( isStoreParentGoal && !isMessageFromMe ) {
				const promises = [
					ioGokr.fetchGoalActivity( { goalId, }, { refetch: true, } ),
					ioGokr.fetchGoal( { goalId, }, { refetch: true, } ),
				];
				const [ activity, goal, ] = ( await Promise.all( promises ) ).map( response => response.data );
				commit( "receiveGoalActivity", activity );
				commit( "receiveParentGoal", goal );
			}
		} );
	} );

	[
		SocketMessageType.KEYRESULT_COMMENT,
	].forEach( socketEvent => {
		debug( `adding socket listener: ${ storeName } <= ${ socketEvent }` );
		ioSocket.addSocketMessageListener( socketEvent, async message => {
			debug( "received socket message", message );
			const { body, clientIdentifier: messageClientIdentifier, } = message;
			const { goalId, keyResultId = "", } = body;
			const isMessageFromMe = ( messageClientIdentifier === clientIdentifier );
			const isStoreKR = keyResultId === getter( "context" ).keyResultId;
			if ( isStoreKR ) {
				const { data: activity, } = await ioGokr.fetchGoalActivity( { goalId, }, { refetch: true, } );
				commit( "receiveGoalActivity", activity );
			}
		} );
	} );
}

export function configureChannels( { storeName, store, navigation, alerts, ioChannel, } ) {
	const debug = debugFactory( `teaming:common-gokr:stores:${ storeName }:channels` );
}
